import { subdomains } from "@/common/consts";
import HomePage from "@/pages/HomePage/HomePage.vue";
import SentencesHome from "@/pages/Sentences/Home/SentencesHome.vue";
import SentenceDetail from "@/pages/Sentences/Detail/SentenceDetail.vue";
import Indice from "@/pages/Indice/Indice.vue";
import Empresa from "@/pages/Empresa/Empresa.vue";
import Contacto from "@/pages/Contacto/Contacto.vue";
import PoliticaDePrivacidad from "@/pages/PoliticaDePrivacidad/PoliticaDePrivacidad.vue";
import CondicionesDeUso from "@/pages/CondicionesDeUso/CondicionesDeUso.vue";
import PoliticaDeCookies from "@/pages/PoliticaDeCookies/PoliticaDeCookies.vue";

export default [
    {
        path: "/",
        name: "Es",
        meta: {
            subdomain: subdomains.ES
        },
        component: HomePage
    },
    {
        path: "/frases",
        name: "Frases",
        meta: {
            subdomain: subdomains.ES
        },
        component: SentencesHome
    },
    {
        path: "/frases/:slug",
        name: "FrasesDetalle",
        meta: {
            subdomain: subdomains.ES
        },
        props: true,
        component: SentenceDetail
    },
    {
        path: "/indice",
        name: "Índice de frases",
        meta: {
            subdomain: subdomains.ES
        },
        component: Indice
    },
    {
        path: "/empresa",
        name: "Empresa",
        meta: {
            subdomain: subdomains.ES
        },
        component: Empresa
    },
    {
        path: "/contacto",
        name: "Contacto",
        meta: {
            subdomain: subdomains.ES
        },
        component: Contacto
    },
    {
        path: "/politica-de-privacidad",
        name: "Política de privacidad",
        meta: {
            subdomain: subdomains.ES
        },
        component: PoliticaDePrivacidad
    },
    {
        path: "/condiciones-de-uso",
        name: "Condiciones de uso",
        meta: {
            subdomain: subdomains.ES
        },
        component: CondicionesDeUso
    },
    {
        path: "/politica-de-cookies",
        name: "Política de Cookies",
        meta: {
            subdomain: subdomains.ES
        },
        component: PoliticaDeCookies
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.es.js